<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>Natural Beauties of Old Montenegro</h1>
    <div class='tourPic'>
      <img src='@/assets/daytours/tour4/01.jpg' />
    </div>

    <div>
      <ul class='fa-ul'>
        <li>
          <!-- <span class='fa-li'><i class='fas fa-tree fa-2x'></i></span>  -->
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDescription'
            ><h4 class='titles'>Tour description</h4></a
          >
          <div class='collapse' id='tourDescription'>
            <p class='pasus'>
              This tour perfectly combines natural beauties and cultural
              heritage of “Old Montenegro” Montenegrins are very proud of. Old
              Montenegro region is the symbol of its independence and
              centuries-long battle for freedom primarily against powerful
              Ottoman Empire and other powerful invaders too. Nevertheless, this
              region offers an abundance of spectacular natural beauties, famous
              viewing points, and rare forests with two national parks almost
              crossing their boundaries…
            </p>
            <p class='pasus'>
              The lookout at Pavlova strana provides the most beautiful view on
              the Skadar Lake and it’s maybe the most famous “postcard” of
              Montenegro while the lookout above Boka Bay is frequently
              mentioned as one of the loveliest in the world. In addition, there
              is a view from “Montenegrin Olimp” – Lovcen Mountain, the symbol
              of Montenegro’s independence whose second largest peak (1660m
              above sea level) is a home to the highest mausoleum in the world,
              dedicated to the most famous ruler, a poet and a philosopher of
              Montenegro – Petar Petrovic II - Njegos.
            </p>
            <p class='pasus'>
              While on this tour we recommend you take a boat trip down meanders
              of Crnojevica river, now submerged in lake water, or we can enjoy
              bird watching (herons, cormorants, pelicans, terns, coots@.),
              rest our eyes surrounded by vastness covered by water lilies and
              water nuts and, if interested, take a bath in clear water of
              pleasant temperature.
            </p>
            <p class='pasus'>
              On our way through national park Lovcen we won't miss the chance
              to take a stroll through an amazing oak forest, breathe deeply the
              air from a famous air spa at Ivanova Korita, drink water from the
              most famous Montenegrin mountain spring@.
            </p>
            <p class='pasus'>
              On our way back from the mountain we will go through the known
              village of Njegusi, the cradle of Petrovic dynasty that had ruled
              Montenegro for 220 years, pay a visit to a local market, taste
              local wines and far-known cheese, Njegusi smoked ham and mead.
            </p>
            <p class='pasus'>We are back in Podgorica at sunset.</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDetails'
            ><h4 class='titles'>Tour details</h4></a
          >
          <div class='collapse' id='tourDetails'>
            <p class='pasus'>Type of tour: Private</p>
            <p class='pasus'>Availability: May – October</p>
            <p class='pasus'>Group size: 1-7</p>
            <p class='pasus'>Depature from: Podgorica</p>
            <p class='pasus'>Difficulty level: easy</p>
            <p class='pasus'>
              Duration: 7-9 h (depending on whether we take a boat ride)
            </p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <h4 class='titles'>Highlights</h4>
          <vue-picture-swipe :items='items'></vue-picture-swipe>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#itinerary'
            ><h4 class='titles'>Itinerary</h4></a
          >
          <div class='collapse' id='itinerary'>
            <ul class='square'>
              <li class='pasus'>
                9 a.m. - a pick up at your place of stay or at the place we
                agree upon.
              </li>
              <li class='pasus'>
                After some half an hour drive we reach the viewing point at
                Pavlova strana where we enjoy the view for some 10 minutes. We
                then descend to a tiny and charming place of Rijeka Crnojevica
                where we take the boat cruise.
              </li>
              <li class='pasus'>
                The cruise down the Rijeka Crnojevica meanders to the open lake
                takes approximately 2 hours.
              </li>
              <li class='pasus'>
                Somewhere around noon we head to the heights and passing through
                Montengrin historical capital – Cetinje, we reach Ivaniva
                Korita, in the heart of Lovcen national park.
              </li>
              <li class='pasus'>
                After we take a walk through beech forest we head to conquer the
                second highest peak of Lovcen where mausoleum is situated (which
                should be around 2 p.m.). On our way to mausoleum we surmount
                461 steps in approximately 15 minutes.
              </li>
              <li class='pasus'>
                Having descended the mausoleum we start our drive around the
                highest part of the massif and after a break at the viewpoint
                over Boka Bay we arrive to a famous and small Njegusi village.
              </li>
              <li class='pasus'>
                After having a lunch or just tasting local specialties – smoked
                ham and cheese, we start our descent from the mountain.
              </li>
              <li class='pasus'>
                9 a.m. - a pick up at your place of stay or at the place we
                agree upon.
              </li>
              <li class='pasus'>
                After some half an hour drive we reach the viewing point at
                Pavlova strana where we enjoy the view for some 10 minutes. We
                then descend to a tiny and charming place of Rijeka Crnojevica
                where we take the boat cruise.
              </li>
              <li class='pasus'>
                The cruise down the Rijeka Crnojevica meanders to the open lake
                takes approximately 2 hours.
              </li>
              <li class='pasus'>
                Somewhere around noon we head to the heights and passing through
                Montengrin historical capital – Cetinje, we reach Ivaniva
                Korita, in the heart of Lovcen national park.
              </li>
              <li class='pasus'>
                After we take a walk through beech forest we head to conquer the
                second highest peak of Lovcen where mausoleum is situated (which
                should be around 2 p.m.). On our way to mausoleum we surmount
                461 steps in approximately 15 minutes.
              </li>
              <li class='pasus'>
                Having descended the mausoleum we start our drive around the
                highest part of the massif and after a break at the viewpoint
                over Boka Bay we arrive to a famous and small Njegusi village.
              </li>
              <li class='pasus'>
                After having a lunch or just tasting local specialties – smoked
                ham and cheese, we start our descent from the mountain.
              </li>
            </ul>
             <div class='tour-time'>
              <p> <i class='fas fa-clock'></i> 2.5 hours</p>
              <p> <i class='fas fa-route'></i> 125 km</p>
            </div>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#prices'
            ><h4 class='titles'>Prices:</h4></a
          >
          <div class='collapse' id='prices'>
            <ul class='square'>
              <li class='pasus'>1 person – 170 EUR</li>
              <li class='pasus'>2 persons – 95 EUR p/person</li>
              <li class='pasus'>3 persons – 75 EUR p/person</li>
              <li class='pasus'>4 persons – 65 EUR p/person</li>
              <li class='pasus'>5 persons - 85 EUR p/person</li>
              <li class='pasus'>6- persons –75 EUR p/person</li>
              <li class='pasus'>7- persons – 70 EUR p/person</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#included'
            ><h4 class='titles'>Included in price:</h4></a
          >
          <div class='collapse' id='included'>
            <ul class='square'>
              <li class='pasus'>Driving by car/van</li>
              <li class='pasus'>Bottle of water</li>
              <li class='pasus'>National park ticket</li>
              <li class='pasus'>Professional guiding service- English</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#info'
            ><h4 class='titles'>Practical info:</h4></a
          >
          <div class='collapse' id='info'>
            <ul class='square'>
              <li class='pasus'>
                We recommend that you carry with you a jacket, a cap,
                sunglasses, some sweets and footwear adequate to conditions in
                the mountain area.
              </li>
              <li class='pasus'>
                - The difference in altitude is 1600 meters. We start at the
                elevation of 50 meters to reach the highest point at 1660
                meters.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#optional'
            ><h4 class='titles'>Optional:</h4></a
          >
          <div class='collapse' id='optional'>
            <ul class='square'>
             <li class='pasus'>Boat cruise on Skadar Lake (1h, 40-50 EUR)</li>
              <li class='pasus'>Walk through Cetinje’s historical center</li>
              <li class='pasus'>Additional walks during the tour</li>
              <li class='pasus'>
                Itinerary changes as agreed (do not affect the price)
              </li>
              <li class='pasus'>Lunch at mountain restaurant</li>
              <li class='pasus'>Visit to a local winery</li>
              <li class='pasus'>Visit to a local honey producer</li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/daytours/tour4/01.jpg'),
          thumbnail: require('@/assets/daytours/tour4/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour4/02.jpg'),
          thumbnail: require('@/assets/daytours/tour4/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour4/03.jpg'),
          thumbnail: require('@/assets/daytours/tour4/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour4/04.jpg'),
          thumbnail: require('@/assets/daytours/tour4/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour4/05.jpg'),
          thumbnail: require('@/assets/daytours/tour4/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour4/06.jpg'),
          thumbnail: require('@/assets/daytours/tour4/06.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour4/07.jpg'),
          thumbnail: require('@/assets/daytours/tour4/07.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour4/08.jpg'),
          thumbnail: require('@/assets/daytours/tour4/08.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour4/09.jpg'),
          thumbnail: require('@/assets/daytours/tour4/09.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour4/10.jpg'),
          thumbnail: require('@/assets/daytours/tour4/10.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour4/11.jpg'),
          thumbnail: require('@/assets/daytours/tour4/11.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour4/12.jpg'),
          thumbnail: require('@/assets/daytours/tour4/12.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour4/13.jpg'),
          thumbnail: require('@/assets/daytours/tour4/13.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour4/14.jpg'),
          thumbnail: require('@/assets/daytours/tour4/14.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/DT4_NaturalBeauties.vue